import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MultiSelect } from "../../../shared/models/common/multiSelect.model";

@Component({
  selector: 'app-staff-playground-edit-rack-modal',
  templateUrl: './staffPlaygroundEditRackModal.component.html',
  styleUrls: ['./staffPlaygroundEditRackModal.component.scss']
})
export class StaffPlaygroundEditRackModalComponent implements OnInit {

    public data: any;
    public racksMultiselectData: MultiSelect;
    public isSelectOpened: boolean;

    constructor(private instance: NgbActiveModal) { }

    ngOnInit() {
        this.racksMultiselectData = this.getRacksMultiselectData();
        this.isSelectOpened = false;
    }

    public selectOpenedChange(isOpened: boolean) {
        this.isSelectOpened = isOpened;
    }

    public Cancel(reason: any) {
        this.instance.dismiss(reason);
    }

    public Save() {
        let staffRacksLimit: any = {};

        staffRacksLimit.staffId = this.data.staffId;
        staffRacksLimit.staffName = this.data.staffName;
        staffRacksLimit.roomNumber = this.data.roomNumber;

        staffRacksLimit.selectedRackIdsArray = [];

        this.racksMultiselectData.selectedValuesObj.value.forEach(item =>
        {
            staffRacksLimit.selectedRackIdsArray.push(item.itemId);
        });

        this.instance.close(staffRacksLimit);
    }

    private getRacksMultiselectData(): MultiSelect {
        let racksMultiselectData = new MultiSelect();

        this.data.assignedRacks.forEach(item => {
            racksMultiselectData.values.push(
                {
                    itemId: item.ccRackId,
                    itemText: item.rack,
                    itemIsSelected: item.isRackSelected,
                    itemExtendedText: item.rackDisplayString
                }
            );
        });

        racksMultiselectData.selectedValuesObj.setValue(racksMultiselectData.values.filter(item => { return item.itemIsSelected; }));
        racksMultiselectData.oldSelectedValues = racksMultiselectData.selectedValuesObj.value.map(x => Object.assign({}, x));

        let onMultiselectChanged = (item: any) => {
            racksMultiselectData.isMultiselectChanged = false;

            racksMultiselectData.oldSelectedValues.forEach(oldItem => {
                let foundOldValue = racksMultiselectData.selectedValuesObj.value.find(newItem => {
                    return oldItem.itemId === newItem.itemId;
                });

                if (!foundOldValue) {
                    racksMultiselectData.isMultiselectChanged = true;
                    return;
                }
            });

            racksMultiselectData.selectedValuesObj.value.forEach(newItem => {
                let foundNewValue = racksMultiselectData.oldSelectedValues.find(oldItem => {
                    return newItem.itemId === oldItem.itemId;
                });

                if (!foundNewValue) {
                    racksMultiselectData.isMultiselectChanged = true;
                    return;
                }
            });
        }

        racksMultiselectData.multiSelectEvents = {
            onSelectionChange: onMultiselectChanged
        }

        return racksMultiselectData;

    }

    private GetModalContainer() {
        return '.fm-ng-wrapper';
    }
}
